






















import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";
import { MIXIN_SCHEME } from "@/constants";

@Component
class BoxDecompose extends Mixins(mixins.page) {
  text: any = "";

  amount = "";

  asset = {
    asset_id: "f5ef6b5d-cc5a-3d90-b2c0-a2fd386e7a3c",
    logo:
      "https://images.mixin.one/ml7tg1ZGrQt6IJSvEusWFfthosOB98GWN7r4EkmgSP8tbJHxK7OWki9zfZFFDCDOJE0nlLBR6dc4nbUguXE3Bg4=s128",
    name: "BOX Token",
    symbol: "BOX"
  };

  get title() {
    return this.$t("trade.box-decompose") as string;
  }

  get valid() {
    return +this.amount > 0;
  }

  async mounted() {
    const isZH = this.$vuetify.lang.current === "zh";
    const text = isZH
      ? await import("@/assets/docs/box_decompose_zh.md")
      : await import("@/assets/docs/box_decompose_en.md");

    this.text = text.default;
  }

  handleTransfer() {
    const scheme =
      MIXIN_SCHEME.PAY +
      `?asset=${this.asset.asset_id}&amount=${this.amount}&recipient=a519e891-1bf7-356d-8ba0-fcc579bc0b0a`;

    window.location.href = scheme;
  }
}
export default BoxDecompose;
